angular.module('app')
    .factory('SummaryService', function (HttpHelper) {
        var fac = {

            lastPage: lastPage,
            firstPage: firstPage,
            prevPage: prevPage,
            nextPage: nextPage,
            getTraceChildren: getTraceChildren,
            getTestIdNameResponse: getTestIdNameResponse,
            getRawMessage: getRawMessage,
            getTraceXmlAttributes: getTraceXmlAttributes,
            getTraceXmlContent: getTraceXmlContent
        };
        // NOTE: Set callerHandlesError = true for paging requests 
        function lastPage(traceSummaryRequest) {
            return HttpHelper.post('api/UtpSummary/LastPage', traceSummaryRequest, true);
        }
        function firstPage(traceSummaryRequest) {
            return HttpHelper.post('api/UtpSummary/FirstPage', traceSummaryRequest, true);
        }
        function prevPage(traceSummaryRequest) {
            return HttpHelper.post('api/UtpSummary/PrevPage', traceSummaryRequest, true);
        }
        function nextPage(traceSummaryRequest) {
            return HttpHelper.post('api/UtpSummary/NextPage', traceSummaryRequest, true);
        }
        function getTraceChildren(traceId) {
            return HttpHelper.get(['api/UtpSummary/GetTraceChildren?TraceId=', traceId].join(''));
        }
        function getTestIdNameResponse(testId) {
            return HttpHelper.get(['api/UtpTest/GetTestIdNameResponse?TestId=', testId].join(''));
        }
        function getRawMessage(id) {
            return HttpHelper.get(['api/UtpAttachment/getRawMessage?id=', id].join(''));
        }
        function getTraceXmlAttributes(traceId) {
            return HttpHelper.get(['api/UtpSummary/getTraceXmlAttributes?traceId=', traceId].join(''));
        }
        function getTraceXmlContent(traceId) {
            return HttpHelper.get(['api/UtpSummary/getTraceXmlContent?traceId=', traceId].join(''));
        }
        return fac;
    }); 